$(document).ready(function(){
  $('.button-open').click(function(){
    $('.nav-2').slideToggle();
  });
 $( window ).resize(function() {
      $(".nav-2").css('display', 'none');
    });
  
}); 
